import {
    flattenPerformanceSummary,
    flattenPerformanceCharts,
    aggregateChartBuckets
} from "../PerformanceReportHelperLib/performanceDataHelper";

export class PerformanceReportData {
    constructor(summaryRaw, chartDataRaw, timeframe) {
        this.timeframe = timeframe;
        this.companySummaries = flattenPerformanceSummary(summaryRaw);
        this.companyCharts = flattenPerformanceCharts(chartDataRaw);
    }

    /**
     * Get aggregated chart bucket data (bar + line) for a given chart type.
     * If companyIdArr is provided, only aggregate those companies.
     * Returns: { barData: number[], lineData: number[] }
     */
    getAggregatedChartData(chartType, companyIdArr = null) {
        return aggregateChartBuckets(
            this.companyCharts,
            chartType,
            this.companySummaries,
            companyIdArr
        );
    }

    /**
     * Get per-company summary data (for the breakdown table).
     * Returns: { companyId: { companyId, summary, totalDeliveries, overview } }
     */
    getCompanySummaries() {
        return this.companySummaries;
    }
}
